export const TAB_OPTIONS = [
  {
    value: "new",
    label: "جدید",
  },
  {
    value: "mine",
    label: "تیکت های من",
  },
  {
    value: "closed",
    label: "بسته شده",
  },
];
